module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9b9-1f3fd-200d-2640-fe0f.3dcb52ba.svg";